<template>
    <div>
        <loading :active.sync="is_loading"
        :can-cancel="true"
        :is-full-page="true"></loading>
        <Navbar />
        <div class="container-fluid">
            <div class="sidebar">
                <SidebarWaterQuality />
            </div>
            <div id="main" class="main">
                <Breadcrumb :links="[{url: '/dashboard', text:'Home'}, {url: '/index-kualitas-air', text: 'Index Kualitas Air'}]"/>
                <h2><b>Overview</b></h2>
                <div class="row mb-3">
                    <div class="col-12 col-md-4">
                        <div class="card">
                            <div class="card-body">
                                <h4 class="mb-4"><b>Citarum</b></h4>
                                <div class="row">
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert alert-success">
                                            <h2 class="text-success"><b>{{ countMemenuhi(this.data.citarum) }}</b></h2>
                                            <span style="font-size: .75rem">Memenuhi</span>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert alert-warning">
                                            <h2 class="text-warning"><b>{{ countCemarRingan(this.data.citarum) }}</b></h2>
                                            <span style="font-size: .75rem">Cemar Ringan</span>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert" style="border: 1px solid #753914; background: #9b7157">
                                            <h2 class="text-light"><b>{{ countCemarSedang(this.data.citarum) }}</b></h2>
                                            <span style="font-size: .75rem" class="text-light">Cemar Sedang</span>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert alert-danger">
                                            <h2 class="text-danger"><b>{{ countCemarBerat(this.data.citarum) }}</b></h2>
                                            <span style="font-size: .75rem">Cemar Berat</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-2 mb-4 pt-3">
                                    <h2>
                                        <b>{{ this.data.citarum.filter(lokasi => lokasi.samplings.length > 0).length }} / {{  this.data.citarum.length }}</b>
                                        <small style="font-size: .9rem;" class="ms-3">Data masuk bulan berjalan</small>
                                    </h2>
                                </div>
                                <router-link to="/index-kualitas-air/citarum">Lihat data <i class="fa fa-arrow-right"></i></router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="card">
                            <div class="card-body">
                                <h4 class="mb-4"><b>Bekasi</b></h4>
                                <div class="row">
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert alert-success">
                                            <h2 class="text-success"><b>{{ countMemenuhi(this.data.bekasi) }}</b></h2>
                                            <span style="font-size: .75rem">Memenuhi</span>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert alert-warning">
                                            <h2 class="text-warning"><b>{{ countCemarRingan(this.data.bekasi) }}</b></h2>
                                            <span style="font-size: .75rem">Cemar Ringan</span>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert" style="border: 1px solid #753914; background: #9b7157">
                                            <h2 class="text-light"><b>{{ countCemarSedang(this.data.bekasi) }}</b></h2>
                                            <span style="font-size: .75rem" class="text-light">Cemar Sedang</span>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert alert-danger">
                                            <h2 class="text-danger"><b>{{ countCemarBerat(this.data.bekasi) }}</b></h2>
                                            <span style="font-size: .75rem">Cemar Berat</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-2 mb-4 pt-3">
                                    <h2>
                                        <b>{{ this.data.bekasi.filter(lokasi => lokasi.samplings.length > 0).length }} / {{  this.data.bekasi.length }}</b>
                                        <small style="font-size: .9rem;" class="ms-3">Data masuk bulan berjalan</small>
                                    </h2>
                                </div>
                                <router-link to="/index-kualitas-air/bekasi">Lihat data <i class="fa fa-arrow-right"></i></router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="card">
                            <div class="card-body">
                                <h4 class="mb-4"><b>Induk Tarum Barat</b></h4>
                                <div class="row">
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert alert-success">
                                            <h2 class="text-success"><b>{{ countMemenuhi(this.data.induk_tarum_barat) }}</b></h2>
                                            <span style="font-size: .75rem">Memenuhi</span>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert alert-warning">
                                            <h2 class="text-warning"><b>{{ countCemarRingan(this.data.induk_tarum_barat) }}</b></h2>
                                            <span style="font-size: .75rem">Cemar Ringan</span>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert" style="border: 1px solid #753914; background: #9b7157">
                                            <h2 class="text-light"><b>{{ countCemarSedang(this.data.induk_tarum_barat) }}</b></h2>
                                            <span style="font-size: .75rem" class="text-light">Cemar Sedang</span>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert alert-danger">
                                            <h2 class="text-danger"><b>{{ countCemarBerat(this.data.induk_tarum_barat) }}</b></h2>
                                            <span style="font-size: .75rem">Cemar Berat</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-2 mb-4 pt-3">
                                    <h2>
                                        <b>{{ this.data.induk_tarum_barat.filter(lokasi => lokasi.samplings.length > 0).length }} / {{  this.data.induk_tarum_barat.length }}</b>
                                        <small style="font-size: .9rem;" class="ms-3">Data masuk bulan berjalan</small>
                                    </h2>
                                </div>
                                <router-link to="/index-kualitas-air/induk tarum barat">Lihat data <i class="fa fa-arrow-right"></i></router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-4">
                        <div class="card">
                            <div class="card-body">
                                <h4 class="mb-4"><b>Sungai Lain</b></h4>
                                <div class="row">
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert alert-success">
                                            <h2 class="text-success"><b>{{ countMemenuhi(this.data.sungai_lain) }}</b></h2>
                                            <span style="font-size: .75rem">Memenuhi</span>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert alert-warning">
                                            <h2 class="text-warning"><b>{{ countCemarRingan(this.data.sungai_lain) }}</b></h2>
                                            <span style="font-size: .75rem">Cemar Ringan</span>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert" style="border: 1px solid #753914; background: #9b7157">
                                            <h2 class="text-light"><b>{{ countCemarSedang(this.data.sungai_lain) }}</b></h2>
                                            <span style="font-size: .75rem" class="text-light">Cemar Sedang</span>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert alert-danger">
                                            <h2 class="text-danger"><b>{{ countCemarBerat(this.data.sungai_lain) }}</b></h2>
                                            <span style="font-size: .75rem">Cemar Berat</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-2 mb-4 pt-3">
                                    <h2>
                                        <b>{{ this.data.sungai_lain.filter(lokasi => lokasi.samplings.length > 0).length }} / {{  this.data.sungai_lain.length }}</b>
                                        <small style="font-size: .9rem;" class="ms-3">Data masuk bulan berjalan</small>
                                    </h2>
                                </div>
                                <router-link to="/index-kualitas-air/sungai lain">Lihat data <i class="fa fa-arrow-right"></i></router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="card">
                            <div class="card-body">
                                <h4 class="mb-4"><b>Induk Tarum Utara</b></h4>
                                <div class="row">
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert alert-success">
                                            <h2 class="text-success"><b>{{ countMemenuhi(this.data.induk_tarum_utara) }}</b></h2>
                                            <span style="font-size: .75rem">Memenuhi</span>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert alert-warning">
                                            <h2 class="text-warning"><b>{{ countCemarRingan(this.data.induk_tarum_utara) }}</b></h2>
                                            <span style="font-size: .75rem">Cemar Ringan</span>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert" style="border: 1px solid #753914; background: #9b7157">
                                            <h2 class="text-light"><b>{{ countCemarSedang(this.data.induk_tarum_utara) }}</b></h2>
                                            <span style="font-size: .75rem" class="text-light">Cemar Sedang</span>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert alert-danger">
                                            <h2 class="text-danger"><b>{{ countCemarBerat(this.data.induk_tarum_utara) }}</b></h2>
                                            <span style="font-size: .75rem">Cemar Berat</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-2 mb-4 pt-3">
                                    <h2>
                                        <b>{{ this.data.induk_tarum_utara.filter(lokasi => lokasi.samplings.length > 0).length }} / {{  this.data.induk_tarum_utara.length }}</b>
                                        <small style="font-size: .9rem;" class="ms-3">Data masuk bulan berjalan</small>
                                    </h2>
                                </div>
                                <router-link to="/index-kualitas-air/induk tarum utara">Lihat data <i class="fa fa-arrow-right"></i></router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="card">
                            <div class="card-body">
                                <h4 class="mb-4"><b>Waduk</b></h4>
                                <div class="row">
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert alert-success">
                                            <h2 class="text-success"><b>{{ countMemenuhi(this.data.waduk) }}</b></h2>
                                            <span style="font-size: .75rem">Memenuhi</span>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert alert-warning">
                                            <h2 class="text-warning"><b>{{ countCemarRingan(this.data.waduk) }}</b></h2>
                                            <span style="font-size: .75rem">Cemar Ringan</span>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert" style="border: 1px solid #753914; background: #9b7157">
                                            <h2 class="text-light"><b>{{ countCemarSedang(this.data.waduk) }}</b></h2>
                                            <span style="font-size: .75rem" class="text-light">Cemar Sedang</span>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 text-center">
                                        <div class="alert alert-danger">
                                            <h2 class="text-danger"><b>{{ countCemarBerat(this.data.waduk) }}</b></h2>
                                            <span style="font-size: .75rem">Cemar Berat</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-2 mb-4 pt-3">
                                    <h2>
                                        <b>{{ this.data.waduk.filter(lokasi => lokasi.samplings.length > 0).length }} / {{  this.data.waduk.length }}</b>
                                        <small style="font-size: .9rem;" class="ms-3">Data masuk bulan berjalan</small>
                                    </h2>
                                </div>
                                <router-link to="/index-kualitas-air/waduk">Lihat data <i class="fa fa-arrow-right"></i></router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Navbar from '../../components/Navbar.vue'
import Breadcrumb from '../../components/Breadcrumb.vue'
import SidebarWaterQuality from '../../components/SidebarWaterQuality.vue'
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import Select2 from 'v-select2-component';

import Datepicker from 'vuejs-datepicker'

export default
{
    components: {
        Navbar,
        Breadcrumb,
        SidebarWaterQuality,
        Loading,
        Datepicker,
        Select2
    },
    data(){
        return {
            is_loading: false,
            data: {
                citarum: [],
                bekasi: [],
                induk_tarum_barat: [],
                sungai_lain: [],
                induk_tarum_utara: [],
                waduk: []
            }
        }
    },
    mounted(){
        this.getData();
    },
    methods: {
        async getData(page) {
            this.is_loading = true;

            const types = ['citarum', 'bekasi', 'induk tarum barat', 'sungai lain', 'induk tarum utara', 'waduk'];

            try {
                const requests = types.map(type => {
                    return axios.get(`${this.$endpoints.wq}/locations`, {
                        params: {
                            tipe: type.toUpperCase(),
                            page
                        }
                    }).then(res => ({ type, data: res.data.data }));
                });

                const responses = await Promise.all(requests);

                // Grouping berdasarkan tipe
                this.data = responses.reduce((acc, curr) => {
                    acc[curr.type.replace(/\s/g, '_')] = curr.data;
                    return acc;
                }, {});
                
            } catch (error) {
                console.error(error);
            } finally {
                this.is_loading = false;
            }
        },
        countMemenuhi(data){
            let total = 0;
            data?.forEach(lokasi => {
                const sampling = lokasi.samplings.length > 0 ? lokasi.samplings[0]:null;
                
                if(sampling !== null){
                    if(sampling.pix <= 1){
                        total += 1;
                    }
                }
            });

            return total;
        },
        countCemarRingan(data){
            let total = 0;
            data?.forEach(lokasi => {
                const sampling = lokasi.samplings.length > 0 ? lokasi.samplings[0]:null;
                
                if(sampling !== null){
                    if(sampling.pix > 1 && sampling.pix <= 5){
                        total += 1;
                    }
                }
            });

            return total;
        },
        countCemarSedang(data){
            let total = 0;
            data?.forEach(lokasi => {
                const sampling = lokasi.samplings.length > 0 ? lokasi.samplings[0]:null;
                
                if(sampling !== null){
                    if(sampling.pix > 5 && sampling.pix <= 10){
                        total += 1;
                    }
                }
            });

            return total;
        },
        countCemarBerat(data){
            let total = 0;
            data?.forEach(lokasi => {
                const sampling = lokasi.samplings.length > 0 ? lokasi.samplings[0]:null;
                
                if(sampling !== null){
                    if(sampling.pix > 10){
                        total += 1;
                    }
                }
            });

            return total;
        }
    }
}

/* if (pix <= 1) {
    return "Memenuhi";
} else if (pix <= 5) {
    return "Cemar Ringan";
} else if (pix <= 10) {
    return "Cemar Sedang";
} else {
    return "Cemar Berat";
} */
</script>